import { render, staticRenderFns } from "./RHumanos.vue?vue&type=template&id=fe24cae6&scoped=true&"
import script from "./RHumanos.vue?vue&type=script&lang=js&"
export * from "./RHumanos.vue?vue&type=script&lang=js&"
import style0 from "./RHumanos.vue?vue&type=style&index=0&id=fe24cae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe24cae6",
  null
  
)

export default component.exports